import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-statics-legal",
  templateUrl: "./statics-legal.component.html",
  styleUrls: ["./statics-legal.component.scss"],
})
export class StaticsLegalComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  close() {
    this.router.navigate(["/"]);
  }
}
